import React from "react";
import { Row } from "reactstrap";

import Stepper from "./steps/Stepper";


const MainReport = (props) => {
   const timestamp=new Date().toString()
    return (
        <div className="content">
            <Row className={"justify-content-center"}>
                <Stepper step={2} timestamp={timestamp} category={1}/>
            </Row>
        </div>
    );
}

export default MainReport;
